import mixpanel from 'mixpanel-browser'
import cloudinary from 'cloudinary-core'
import {
  CLOUDINARY_NAME,
  CLOUDINARY_API_KEY,
} from '../../../constants/images/cloudinary'
import * as Cookies from 'js-cookie'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

export const trackEmailConfirmationResent = (params) => {
  mixpanel.track('Email Confirmation Resent', {
    parent_description: params.parent,
  })
}

export const trackEmailConfirmationResentAttempt = (params) => {
  mixpanel.track('Email Confirmation Resent Attempted', {
    error_message: params.error_messsage,
    error_code: params.error_code,
    error_type: params.error_type,
    parent_description: params.parent,
  })
}

export const trackProfilePhotoChange = (params) => {
  //need to install this on the account profile picture calls
  mixpanel.track('Profile Photo Changed', {
    profile_photo_large: cl.url(params.profile_photo, {
      gravity: 'center',
      height: 300,
      width: 300,
      crop: 'fill',
      format: 'jpg',
    }),
    profile_photo_small: cl.url(params.profile_photo, {
      gravity: 'center',
      height: 125,
      width: 125,
      crop: 'fill',
      format: 'jpg',
    }),
    parent_description: params.parent,
  })
  mixpanel.people.set({
    profile_photo_large: cl.url(params.profile_photo, {
      gravity: 'center',
      height: 300,
      width: 300,
      crop: 'fill',
      format: 'jpg',
    }),
    profile_photo_small: cl.url(params.profile_photo, {
      gravity: 'center',
      height: 125,
      width: 125,
      crop: 'fill',
      format: 'jpg',
    }),
    $avatar: cl.url(params.profile_photo, {
      gravity: 'center',
      height: 125,
      width: 125,
      crop: 'fill',
      format: 'jpg',
    }),
  })
  mixpanel.identify(Cookies.get('userID'))
}

export const trackprofilePhotoChangeAttempt = (params) => {
  mixpanel.track('Profile Photo Change Attempted', {
    error_message: params.error_messsage,
    error_code: params.error_code,
    error_type: params.error_type,
    parent_description: params.parent,
  })
}

export const trackPhoneChange = (params) => {
  //install this on account pages
  mixpanel.track('Phone Number Changed', {
    phone: params.phone,
    parent_description: params.parent,
  })

  mixpanel.people.set({
    $phone: params.phone,
  })
  mixpanel.identify(Cookies.get('userID'))
}

export const trackPhoneVerified = (params) => {
  mixpanel.track('Phone Number Verified', {
    parent_description: params.parent,
  })

  mixpanel.people.set({
    'Phone Verified': true,
  })
  mixpanel.identify(Cookies.get('userID'))
}

export const trackPhoneChangeAttempt = (params) => {
  mixpanel.track('Phone Number Change Attempted', {
    phone: params.phone,
    error_message: params.error_messsage,
    error_code: params.error_code,
    error_type: params.error_type,
    parent_description: params.parent,
  })
}

export const trackPhoneVerifiedAttempt = (params) => {
  mixpanel.track('Phone Number Verify Attempted', {
    phone: params.phone,
    phone_verf_code: params.code,
    error_message: params.error_messsage,
    error_code: params.error_code,
    error_type: params.error_type,
    parent_description: params.parent,
  })
}
export const trackViewedOwnProfile = () => {
  //check this works
  mixpanel.track('Viewed Own User Page')
}

export const trackAccountPasswordChanged = () => {
  mixpanel.track('Account Settings Changed - Password')
}

export const trackAccountBasicInfoChanged = () => {
  mixpanel.track('Account Settings Changed - User Info')
  //feed name and other info into this
}

export const trackAccountLicenseInsuranceChanged = () => {
  mixpanel.track('Account Settings Changed - License/Insurance')
}

export const trackAccountProfilePhotoChanged = () => {
  mixpanel.track('Account Settings Changed - Profile Photo')
  //need to update the profile photo here.
}

export const trackPaymentMethodAdded = () => {
  mixpanel.track('Payment Method Added')
}
